import {
  Button,
  Divider,
  Grid,
  Typography,
  styled,
  useTheme,
} from "@mui/material";

import { AddOne } from "assets/Icon";
import React from "react";

function ButtonAddBankAccounts({ onClick }) {
  const theme = useTheme();
  return (
    <Grid item xs={12}>
      <ButtonAdd onClick={onClick} variant="text">
        <Typography variant="h5">افزودن حساب بانکی</Typography>
        <AddOne color={theme.palette.secondary.main} />
      </ButtonAdd>

      <Divider />
    </Grid>
  );
}

const ButtonAdd = styled(Button)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  marginLeft: "auto",
  color: theme.palette.secondary.main,
  svg: {
    width: "40px",
    paddingLeft: theme.spacing(1),
  },
}));
export default ButtonAddBankAccounts;
